import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { removeEventError } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return (event) => {
    return present(
      repository
        .removeEvent(event)
        .then(() => event)
        .catch((e) =>
          Promise.reject({ error: { ...removeEventError, ...e }, event }),
        ),
    );
  };
}

export type { Interactor };

export { createInteractor };
